module.exports = __webpack_public_path__ + "static/media/envelope-open-text.997b1656.svg";